import React from 'react'
import Logo from '../../../assets/images/logo.png'

function Header() {
  return (
    <>
      <button onClick={() => document.location.hash=`main-content`} className="skip-to-content">Skip to Content</button>
      
      <header>
        <img className="logo" src={Logo} alt="" width="198" height="57"></img>
      </header>
    </>
  )
}

export default Header